import FetchApiError from "@/lib/openapi/api-error";
import {
  ExtractFetchParams,
  ExtractMutationOptions,
  ExtractResponse,
  useMutationRequest,
} from "@/lib/openapi/hooks";
import { useQueryClient } from "@tanstack/react-query";

export type PostPreviousSwitchResponse = ExtractResponse<
  "telegramAuthorization",
  "/users/switch/previous",
  "post"
>;

export type PostPreviousSwitchFetchParams = ExtractFetchParams<
  "telegramAuthorization",
  "/users/switch/previous",
  "post"
>;

export const usePostPreviousSwitchMutate = ({
  queryOptions,
}: {
  queryOptions?: ExtractMutationOptions<
    PostPreviousSwitchResponse,
    FetchApiError,
    PostPreviousSwitchFetchParams,
    unknown
  >;
} = {}) => {
  const queryClient = useQueryClient();
  return useMutationRequest("telegramAuthorization", "/users/switch/previous", {
    method: "post",
    queryOptions: {
      onSuccess: async (...args) => {
        await queryClient.invalidateQueries();
        queryOptions?.onSuccess?.(...args);
      },
    },
  });
};

export default usePostPreviousSwitchMutate;
